import PropTypes from 'prop-types';
import Wrapper from '../common/Wrapper/Wrapper';
import { Icon } from '../common/Icons';
import Heading from '../Heading/Heading';
import StorySlider from '../StorySlider/StorySlider';
import { StyledContainer } from './StoryList.styles';

function StoryList({
  data,
  onLoadMoreClick,
  heading,
  loadMore,
  sidebar,
  mobileVertical,
  border,
  onClick,
}) {
  const { type, arrow, title } = heading;

  return (
    <StyledContainer
      bgcolor={type === 'trending'}
      type={sidebar ? 'sidebar' : undefined}
      mobileVertical={mobileVertical}
      border={border}
    >
      <Wrapper>
        <Heading
          icon={
            type === 'trending' ? (
              <Icon.Fire aria-hidden />
            ) : type === 'liked' ? (
              <Icon.Heart aria-hidden />
            ) : type === 'recommended' || type === 'related' ? (
              <Icon.Recommended aria-hidden />
            ) : null
          }
          title={title}
          arrow={arrow}
          type="h2"
          styling="font-14-semi-bold"
        />
      </Wrapper>
      <StorySlider
        stories={data}
        loadMore={loadMore}
        onLoadMoreClick={onLoadMoreClick}
        sidebar={sidebar}
        mobileVertical={mobileVertical}
        onClick={onClick}
      />
    </StyledContainer>
  );
}

StoryList.propTypes = {
  data: PropTypes.array,
  loadMore: PropTypes.bool,
  heading: PropTypes.shape({
    type: PropTypes.string,
    arrow: PropTypes.bool,
    title: PropTypes.string,
  }),
  sidebar: PropTypes.bool,
  border: PropTypes.bool,
};

StoryList.defaultProps = {
  data: [],
  loadMore: false,
  heading: {},
  sidebar: false,
  border: true,
};

export default StoryList;
